import React from "react";

const Hero = ({ data }) => {

   // Example: Color "Inspire" and "Vision"
   const highlightWords = ["Tenant", "Management", "Property", "&", "Units", "Starts", "Here", "Maintenance", "Issues", "Your", "Properties", "Instant", "Updates", "Lease", "Date", "Again"];
   const words = data.title.split(" ");

  return (
    <div className="text-center py-24 lg:py-32 relative">
      <h1 className="text-4xl lg:text-6xl xl:text-7xl lg:tracking-[-6px] font-popinsBold text-themeColor w-[70%] mx-auto">
        {words.map((word, index) => {
          const cleanWord = word.replace(/[^\w]/g, ""); // remove punctuation
          const isHighlight = highlightWords.includes(cleanWord);
          return (
            <span
              key={index}
              className={isHighlight ? "text-btnColor" : ""}
            >
              {word}{" "}
            </span>
          );
        })}
      </h1>
      <p className="font-popinsRegular text-textColor text-base lg:text-lg w-[90%] lg:w-[65%] mx-auto pt-5">
        {data.subtitle}
      </p>
      <div className="absolute left-0 bottom-10 size-40 xl:size-48 2xl:size-56 hidden lg:block">
        <img src="/assets/hero.png" alt="" className="size-full object-fill" />
      </div>
    </div>
  );
};

export default Hero;
